import Button from "@/components/Common/Button";
import Modal from "@/components/Common/Modal";
import useCustomerCreation from "@/hooks/useCustomerCreation";
import {useAgencyId, useSelectedAgency} from "@/hooks/useUserHooks";
import CreateCustomerContent from "@/pages/agencies/CreateCustomerContent";
import {createCustomerModalOpenAtom, settingsModalAtom} from "@/store/jotaiAtoms";
import {useNavigate} from "@tanstack/react-router";
import {useSetAtom} from "jotai";
import {type FC} from "react";
import {useTranslation} from "react-i18next";

const CreateCustomerModal: FC = () => {
  const {t} = useTranslation(["multi_account", "common"]);
  const navigate = useNavigate();
  const agencyId = useAgencyId();
  const agency = useSelectedAgency();
  const setIsModalOpen = useSetAtom(createCustomerModalOpenAtom);
  const setSettingsModal = useSetAtom(settingsModalAtom);

  const customerCreation = useCustomerCreation({
    agencyId,
    onSuccess: companyId => {
      setIsModalOpen(false);
      navigate({
        to: "/agency/$agencyId/subbrand/$companyId",
        params: {agencyId: agencyId!, companyId},
      });
      setSettingsModal({scope: {id: companyId, type: "brand"}, section: "info"});
    },
  });

  return (
    <Modal
      className="gap-0 px-0"
      onClose={() => {
        if (!customerCreation.isDynamicAddressFocused) {
          setIsModalOpen(false);
          customerCreation.reset();
        }
      }}
      customBottomRow={
        <div className="flex justify-end p-5">
          <Button
            dataTestId="create-customer-button"
            onClick={() => customerCreation.create()}
            buttonStyle="Gradient"
            isDisabled={customerCreation.isCreateDisabled}
            isLoading={customerCreation.isCreating}
            className="h-15 w-[40%]">
            {t("common:create")}
          </Button>
        </div>
      }
      backgroundClassName="max-w-3xl"
      modalTitle={t(agency?.large_brand ? "new_company" : "new_customer")}>
      <CreateCustomerContent customerCreation={customerCreation} isLargeBrand={agency?.large_brand} />
    </Modal>
  );
};

export default CreateCustomerModal;
